// extracted by mini-css-extract-plugin
export default {"pdfContainer":"_EZA1EFh5A9beQD0zKEn","pdfContainerWithZoom":"mAwUQzdzpRmL3pnAtz96","zoomControlContainer":"KvhxXi368YPqGznzXIK2","pageNumberContainer":"Msumc4Ff7LaI9IG4pJf6"};